// eslint-disable-next-line angular/factory-name
angular.
module("digiexam.services").
factory("settingFlags", function settingFlagsFactory() {
	"use strict";

	return {
		NONE: 0,
		OFFLINE_START: 1,
		TRADITIONAL_EXAM: 2,
		CHEAT_VIRTUAL_MACHINE: 4,
		STUDENT_ABSENT: 32,
	};
});
